<template>
  <v-snackbar
    v-model="snackBarStore.show"
    multi-line
    location="top"
    :color="snackBarStore.color"
    :timeout="snackBarStore.timeout"
    :vertical="snackBarStore.vertical"
  >
    <h3>{{ snackBarStore.title }}</h3>
    {{ snackBarStore.message }}
    <template v-slot:actions>
      <v-btn variant="text" @click="snackBarStore.hide()">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useSnackBarStore } from "@/stores/snackBarStore";

const snackBarStore = useSnackBarStore();
</script>
